import { ADMIN } from '../consts'
import { useAuth } from '../context/AuthContext'
export enum PermissionAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Read = 'read',
  ReadAll = 'read_all'
}

export const checkPermission = (
  currentUser: any,
  model: string,
  action: PermissionAction
) => {
  if (ADMIN?.includes(currentUser?.role?.name)) return true
  const permissionModel = currentUser?.permissions?.find(
    (x: any) => x.model_name === model
  )
  if (!permissionModel) return false
  return permissionModel[action]
}
export const useCheckPermission = (model: string, action: PermissionAction) => {
  const { currentUser } = useAuth()
  if (ADMIN?.includes(currentUser?.role?.name!)) return true
  const permissionModel = currentUser?.permissions?.find(
    (x: any) => x.model_name === model
  )
  if (!permissionModel) return false
  return permissionModel[action as keyof typeof permissionModel]
}
